import { render } from "./OfflineOrderItem.vue?vue&type=template&id=0b817154&scoped=true"
import script from "./OfflineOrderItem.vue?vue&type=script&lang=js"
export * from "./OfflineOrderItem.vue?vue&type=script&lang=js"

import "./OfflineOrderItem.vue?vue&type=style&index=0&id=0b817154&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b817154"]])

export default __exports__